import { ScrollArea, Stack } from "@mantine/core"

import type { LibraryResponses } from "@tfg/types/endpoints/library"

import { CustomFieldItemTree } from "~/pages/Brand/Products/Details/CustomFieldGraph/CustomFieldItemTree"
import {
  filterOperationsByIds,
  findCustomFieldTreeRoot,
} from "~/pages/Brand/Products/Details/CustomFieldGraph/custom-field-fork-branches"
import { useCustomFieldGraphData } from "~/pages/Brand/Products/Details/CustomFieldGraph/useCustomFieldGraphData"

type Props = {
  readonly product: LibraryResponses.ProductDetails
}

export const ProductCustomFieldGraph = ({ product }: Props) => {
  const { getMainOperations, forkBranches } = useCustomFieldGraphData(product)

  return (
    <ScrollArea w="100%" type="scroll" offsetScrollbars>
      <Stack gap="xl" mb="xl">
        <CustomFieldItemTree
          product={product}
          root={{ kind: "product", product }}
          getOperations={getMainOperations}
        />
        {forkBranches.map((branch) => {
          const root = findCustomFieldTreeRoot(product, branch.anchorItemId)
          if (root === undefined) {
            return null
          }

          return (
            <CustomFieldItemTree
              key={branch.contextId}
              product={product}
              root={root}
              originCue={branch.originCue}
              getOperations={(item) =>
                filterOperationsByIds(
                  item.operations,
                  branch.operationIdsByItemId.get(item.id)
                )
              }
            />
          )
        })}
      </Stack>
    </ScrollArea>
  )
}
